import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const ShakerPlaylist: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'shakerlandingpage_title_generatecollaborativeplaylist_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'shakerlandingpage_text_generatecollaborativeplaylist_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'discover'}}
						target="_blank"
						href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fmusictogether%2Fgroups&amv=8.0.34&imv=10.34.0&gwf=https%3A%2F%2Fshaker.deezer.com%2Fgroups"
					>
						{t('musictogether_action_tryshaker_standalone-web', {
							ns: 'common',
						})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					src="7d594d8d98c4ac8302e391786e2a0ae8.png"
					aspectRatio="2880/1012"
					objectFit="contain"
					alt={'Shaker'}
				/>
			}
		/>
	);
};
